import { render, staticRenderFns } from "./MaterialsStockProducts.vue?vue&type=template&id=66cf2ef1&"
import script from "./MaterialsStockProducts.vue?vue&type=script&lang=js&"
export * from "./MaterialsStockProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports